import { useState } from 'react'

import { Boton } from '@/shared/ui/Boton/Boton'

import { usePasarAPrecierre } from './usePrecierre'
import estilos from './PasarAPrecierre.module.css'

/**
 * PASAR A PRECIERRE DESDE GERENCIA (0269).
 *
 * Johan: «debería tener la opción para yo moverlo a PRECIERRE en caso tal que
 * el técnico no pueda». Hace lo que hace la orden sola al vencerse: cierra la
 * visita abierta y la deja esperando la decisión de cierre. El motivo es
 * obligatorio y le llega al técnico.
 */
export function PasarAPrecierre({ ordenTrabajoId }: { ordenTrabajoId: string }) {
  const pasar = usePasarAPrecierre()
  const [abierto, setAbierto] = useState(false)
  const [motivo, setMotivo] = useState('')

  if (!abierto) {
    return (
      <Boton
        variante="secundario"
        onClick={() => {
          pasar.reset()
          setAbierto(true)
        }}
      >
        Pasar a precierre
      </Boton>
    )
  }

  const corto = motivo.trim().length < 10

  return (
    <div className={estilos.caja}>
      <p className={estilos.titulo}>Pasar a precierre</p>
      <p className={estilos.texto}>
        Para cuando el técnico no puede hacerlo desde su teléfono. Si marcó llegada y no salida, la
        salida se estima. Después se cierra como siempre: con foto de evidencia o firma del acta.
      </p>
      <textarea
        className={estilos.campo}
        rows={3}
        value={motivo}
        onChange={(e) => setMotivo(e.target.value)}
        placeholder="¿Por qué la pasa usted? Ej.: el técnico se quedó sin batería y ya terminó."
        aria-label="Motivo para pasar a precierre"
        autoFocus
      />
      {pasar.error && <p className={estilos.error}>{pasar.error.message}</p>}
      <div className={estilos.botones}>
        <Boton
          variante="principal"
          onClick={() =>
            pasar.mutate(
              { ordenTrabajoId, motivo: motivo.trim() },
              {
                onSuccess: () => {
                  setAbierto(false)
                  setMotivo('')
                },
              },
            )
          }
          trabajando={pasar.isPending}
          disabled={corto}
        >
          Pasar a precierre
        </Boton>
        <Boton variante="secundario" onClick={() => setAbierto(false)}>
          Cancelar
        </Boton>
        <span className={estilos.nota}>Le llega al técnico y queda en la bitácora.</span>
      </div>
    </div>
  )
}
